export default {
  feedbackFrames: [],
  feedbackTracks: [],
  info: {},
  initialize: [],
  setting: {},
  branding: {},
  language: null,
};
